import React            from "react";
import Router           from "next/router";
import { useSetDrawer } from "_common/hooks/global";
import Presentation     from "./presentation";
import { storeEvent }   from "_root/analytics";

const component = ( { hidden } ) => {

	const setDrawer = useSetDrawer ();

	const setHeader = () => {
		setDrawer ( true );
	};

	const goBackToPreviousPage = () => {
		Router.back ();
	};

	const handleGAEvent = type => {
		switch ( type ) {
			case "rooterLogo":
				storeEvent ( "Home", "Rooter_icon" );
				break;

			case "rewardsIcon":
				storeEvent ( "Reward", "Clicked" );
				break;

			default:
				break;
		}
	};

	return (
		<Presentation
			goBackToPreviousPage  = { goBackToPreviousPage }
			handleGAEvent         = { handleGAEvent }
			hidden                = { hidden }
			Router                = { Router }
			setHeader             = { setHeader }
		/>
	);
};

export default component;
